export enum CodeKeyType {
	DEFAULT = "default",
	VIM = "vim",
}
